import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
export interface Medication {
  rx_id?: string;
  dateWritten?: any;
  dosage?: string;
  id?: string;
  medref?: string;
  name?: string;
  prescriber?: string;
  dosageAmount?: number;
  dosageMeasure?: string;
  form?: string;
  doc?: any;
  index?: number;
  frequency: string;
  hours: string[];
  status?: MedicationStatus;
  statusReason?: string;
  priorPrescription?: string;
}

export enum MedicationStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ON_HOLD = 'on-hold',
  ENDED = 'ended',
  STOPPED = 'stopped',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  ENTERED_IN_ERROR = 'entered-in-error',
  UNKNOWN = 'unknown',
}

export enum MedicationStatusReason {
  PREGNANCY = 'Pregnancy',
  ALLERGY = 'Allergy',
  DUPLICATE_THERAPY = 'Duplicate therapy',
  SIDE_EFFECTS = 'Side effects',
  DRUG_INTERACTION = 'Drug interaction',
  PATIENT_REQUEST = 'Patient request',
  INEFFECTIVE = 'Ineffective',
  OTHER = 'Other',
}

export enum MedicationHours {
  AM = 'AM',
  PM = 'PM',
  EVENING = 'Evening',
  AS_NEEDED = 'As needed',
}

export enum MedicationDoseType {
  BUCCAL = 'Buccal',
  INHALATION = 'Inhalation',
  INJECTION = 'Injection',
  INTRAMUSCULAR = 'Intramuscular (IM)',
  INTRANASAL = 'Intranasal',
  INTRAVENOUS = 'Intravenous (IV)',
  NASAL_SOLUTION = 'Nasal Solution',
  ORAL = 'Oral (PO)',
  ORAL_CAPSULE = 'Oral Capsule',
  ORAL_TABLET = 'Oral Tablet',
  RECTAL = 'Rectal (PR)',
  SUBCUTANEOUS = 'Subcutaneous (SC)',
  SUBLINGUAL = 'Sublingual (SL)',
  TOPICAL = 'Topical',
  TRANSDERMAL = 'Transdermal',
  OTHER = 'Other',
}

export enum MedicationDoseMeasure {
  GRAM = 'g',
  MG = 'mG',
  MCG = 'MCG',
  IU = 'IU',
  MEQ = 'mEq',
  L = 'L',
  ML = 'mL',
  PERCENT = '%',
  OTHER = 'Other',
}

export enum MedicationReminderFrequency {
  EVERY_DAY = 'every_day',
  SPECIFIC_DAYS = 'specific_days',
}

export enum WeekDay {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export enum TimePeriod {
  AM = 'AM',
  PM = 'PM',
}

export interface Diagnosis {
  id?: string;
  association?: DiagnosisAssociation;
  code_system?: string;
  code_value?: string;
  date_recorded?: any;
  diagnosis?: string;
  status?: string;
  userID?: string;
  doc?: any;
  index?: number;
}

interface DiagnosisAssociation {
  ccm: boolean;
  rpm: boolean;
  pcm: boolean;
  bhi: boolean;
  apcm: boolean;
}

export interface Allergy {
  id?: string;
  code: string;
  category: string;
  clinicalStatus: FhirAllergyClinicalStatus;
  note: string;
  criticality: string;
  recordedDate: Date | firebase.firestore.Timestamp;
  verificationStatus: FhirVerificationStatus;
  doc?: any;
  index?: number;
}

export enum FhirAllergyClinicalStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  RESOLVED = 'Resolved',
}

export enum FhirVerificationStatus {
  CONFIRMED = 'Confirmed',
  UNCONFIRMED = 'Unconfirmed',
  REFUTED = 'Refuted',
  ERROR = 'Entered in error',
}

export interface MedicationReminder {
  id?: string;
  medicationId: string;
  isActive: boolean;
  frequency: string;
  days: {
    sunday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
  };
  times: string[];
}
